"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDonutChartWrapper = exports.StyledDashboardWidgetBar = exports.StyledDashboardWidgetBars = exports.StyledDashboardWidgetProductStatusItemValue = exports.StyledDashboardWidgetItemSquare = exports.StyledDashboardWidgetItemLabelTypography = exports.StyledDashboardWidgetProductItemLabel = exports.StyledDashboardWidgetTopRow = exports.StyledDonutWrapper = exports.StyledDashboardWidgetAttributeLabelContainer = exports.StyledDashboardWidgetLabelContainer = exports.StyledDashboardWidgetContainer = exports.StyledDashboardWidgetItemValue = exports.StyledDashboardWidgetItemLabel = exports.StyledDashboardWidgetItemWrapper = exports.StyledDashboardWidgetTitle = exports.StyledDashboardWidgetWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const widget_1 = require("../../components/widget");
exports.StyledDashboardWidgetWrapper = (0, styled_components_1.default)(widget_1.Widget) `
  padding: ${({ theme }) => theme.spacing(3)};  
  box-sizing: border-box;
`;
exports.StyledDashboardWidgetTitle = (0, styled_components_1.default)(ui_components_1.Typography) `
  color: ${ui_components_1.baseColors.primaryBlueMed600};
  text-transform: uppercase;

  font-weight: 400;
  line-height: 26px;
  font-size: 1rem;
`;
exports.StyledDashboardWidgetItemWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledDashboardWidgetItemLabel = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-size: 0.75rem;
  color: ${ui_components_1.baseColors.primaryBlueMed600};
`;
exports.StyledDashboardWidgetItemValue = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-weight: 600;
  color: ${ui_components_1.baseColors.primaryBlueDark500};
`;
exports.StyledDashboardWidgetContainer = styled_components_1.default.div `
  width: 100%;
`;
exports.StyledDashboardWidgetLabelContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-direction: column;
`;
exports.StyledDashboardWidgetAttributeLabelContainer = (0, styled_components_1.default)(exports.StyledDashboardWidgetLabelContainer) `
  flex-direction: row;
`;
exports.StyledDonutWrapper = styled_components_1.default.div `
   display: flex;
   justify-content: center;
`;
exports.StyledDashboardWidgetTopRow = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;
`;
exports.StyledDashboardWidgetProductItemLabel = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  
  > div {
    display: flex;
    align-items: center;
  }
`;
exports.StyledDashboardWidgetItemLabelTypography = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${ui_components_1.baseColors.primaryBlueMed600};
`;
exports.StyledDashboardWidgetItemSquare = styled_components_1.default.span `
  width: 16px;
  height: 16px;
  margin-left: 8px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;
exports.StyledDashboardWidgetProductStatusItemValue = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  font-feature-settings: 'liga' off, 'clig' off;
`;
exports.StyledDashboardWidgetBars = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  height: auto;
`;
exports.StyledDashboardWidgetBar = styled_components_1.default.div `
  height: 16px;
  background-color: ${(props) => props.color};
  width: ${(props) => props.width}%;
  border-radius: 4px;
`;
exports.StyledDonutChartWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
`;
